const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#042b5f',
                hover: '#133566'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
